import React from 'react';
import { JOBS_SEARCH_PATH, ORGANIZATIONS_SEARCH_PATH } from '../../../utilities/devex_paths';
import styles from './no_jobs.module.scss';

interface Props {
  isAdmin: boolean;
}

const NoJobs = ({ isAdmin }: Props) => {
  const isAdminMessage = (
    <div data-testid='is-admin-message' className='d-flex flex-column align-items-start'>
      <p className='my-4'>0 open jobs available right now.</p>
    </div>
  );

  const anchorStyles = 'btn btn-link link-blue-orange';

  const isNotAdminMessage = (
    <div data-testid='not-admin-message' className='d-flex flex-column align-items-start mt-3'>
      <p>There are no jobs posted for this organization.</p>
      <p>
        You could search for other{' '}
        <a data-testid='search-orgs' href={ORGANIZATIONS_SEARCH_PATH} className={anchorStyles}>
          organizations
        </a>{' '}
        or check our{' '}
        <a data-testid='search-jobs' href={JOBS_SEARCH_PATH} className={anchorStyles}>
          job board
        </a>
        .
      </p>
    </div>
  );
  return (
    <div className={styles.noJobsContainer} data-testid='no-jobs'>
      {isAdmin ? isAdminMessage : isNotAdminMessage}
    </div>
  );
};

export default NoJobs;
